import { IPaginationReturn } from '../../interfaces/IPaginationReturn';
import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import IPost from '../../interfaces/IPost';

export interface IFilterPost {
  id?: number | null;
}

const usePostService = () => {
  const Subsidiary = useRequest<IPost>();
  const path = 'employee/post';

  const list = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    direction: 'asc' | 'desc',
    filter?: IFilterPost,
  ): Promise<IPaginationReturn<IPost[]>> => {
    return await Subsidiary.postAndGetManyPaginated({
      path: `${path}/list?perPage=${perPage}&currentPage=${currentPage}&orderBy=${orderField}&orderDirection=${direction}`,
      sendAuthorization: true,
      body: { ...filter },
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const findById = async (id: number): Promise<IPost> => {
    return await Subsidiary.getOne({
      path: `${path}/${id}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listPostByName = async (name: string): Promise<IPost[]> => {
    return await Subsidiary.getMany({
      path: `${path}/findByName/${name}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listPostBySubsidiaryId = async (id: number): Promise<IPost[]> => {
    return await Subsidiary.getMany({
      path: `${path}/ListBySubsidiaryId/${id}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listPostSearch = async (filter: string): Promise<IPost[]> => {
    if (filter === '') {
      filter = ' ';
    }

    const url = filter
      ? `${path}/search?perPage=300&currentPage=1&orderBy=code&orderDirection=asc&filter=${filter}`
      : `${path}/search?perPage=300&currentPage=1&orderBy=code&orderDirection=asc&filter= `;

    return await Subsidiary.getManyPaginated({
      path: url,
      sendAuthorization: true,
    })
      .then(result => {
        return result?.data;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async ({ code, name }: IPost): Promise<IPost> => {
    return await Subsidiary.post({
      path: `${path}`,
      sendAuthorization: true,
      body: { code, name },
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: number, { code, name }: IPost): Promise<IPost> => {
    return await Subsidiary.put({
      path: `${path}/${id}`,
      sendAuthorization: true,
      body: { code, name },
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: number): Promise<void> => {
    return await Subsidiary.remove({
      path: `${path}/${id}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { list, listPostByName, findById, listPostSearch, listPostBySubsidiaryId, create, update, remove };
};

export { usePostService };
